//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

// Maps to ExperienceContainerType in experience-web-gateway
export enum ExperienceContainerType {
  HOMEPAGE = 'homepage',
  PRODUCT = 'product',
  CATEGORY = 'category',
  DYNAMIC_LANDING_PAGE = 'dynamic-landing-page',
  OTHER = 'other',
  INSTASHOP = 'instashop',

  // Deprecated: These are only used by the pre-Galleries Fanreel Self-Serve page
  GALLERY = 'gallery',
  CAMPAIGN = 'campaign'
}
